import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PackageService {

  constructor(private http: HttpClient) { }

  getAllPackage(data: any): Observable<any> {
    return this.http.post(environment.getAllPackages, data);
  }

  createPackage(data: any): Observable<any> {
    return this.http.post(environment.createPackage, data);
  }

  updatePackage(data: any): Observable<any> {
    return this.http.post(environment.updatePackage, data);
  }

  deletePackage(data: any): Observable<any> {
    return this.http.post(environment.deletePackage, data);
  }
  createPackageSubscription(data: any): Observable<any> {
    return this.http.post(environment.createPackageSubscription, data);
  }
  getAllPackageSubscription(data: any): Observable<any> {
    return this.http.post(environment.getAllPackageSubscription, data);
  }

  updatePackageSubscription(data: any): Observable<any> {
    return this.http.post(environment.updatePackageSubscription, data);
  }

  deletePackageSubscription(data: any): Observable<any> {
    return this.http.post(environment.deletePackageSubscription, data);
  }
  getAllAddonSubscription(data: any): Observable<any> {
    return this.http.post(environment.getAllAddonSubscription, data);
  }
   proformaPackageInvoice(data: any): Observable<any> {
    return this.http.post(environment.proformaPackageInvoice, data);
  }
  generatePackageInvoice(data: any): Observable<any> {
    return this.http.post(environment.generatePackageInvoice, data);
  }

   cancelAndRefundSubscription(data: any): Observable<any> {
    return this.http.post(environment.cancelAndRefundSubscription, data);
  }

  getAllPackageInvoices(data: any): Observable<any> {
    return this.http.post(environment.getAllPackageInvoices, data);
  }
  restartSubscription(data: any): Observable<any> {
    return this.http.post(environment.restartSubscription, data);
  }

  upgradePackageSubscription(data: any): Observable<any> {
    return this.http.post(environment.upgradePackageSubscription, data);
  }

  onboardExistingClient(data: any): Observable<any> {
    return this.http.post(environment.onboardExistingClient, data);
  }
  
  
}